<p-toast key="tst" [style]="{marginTop: '70px'}"></p-toast>
<!-- RECOVER CARD -->
<section class="recoverPassword">


    <form class="card p-fluid p-col-12 p-md-6  ui-g ui-fluid top-buffer recoverPasswordFrom"
        [formGroup]="recoverPasswordFrom">


        <div class="p-d-flex p-flex-row p-col-4" *ngIf="device != '2'">
            <div class="ui-xl-2 ui-lg-3 ui-md-3 ui-g-3">
                <button pButton class="button-back" pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
            </div>
        </div>

        <h4 class="recoverPasswordFrom__title" *ngIf="device != '2'">{{lbl_recover_password}}</h4><br />
        <!-- INPUT -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-google"></i>
                    </span>
                    <span class="p-float-label">
                        <input tabIndex="1" formControlName="currentEmail" type="email" aria-describedby="current-help"
                            pInputText />
                        <label htmlFor="currentEmailInput">{{lbl_email}}</label>
                    </span>
                </div>
                <!--
                <div *ngIf="recoverPasswordFrom.controls['currentEmail'].invalid && (recoverPasswordFrom.controls['currentEmail'].dirty || recoverPasswordFrom.controls['currentEmail'].touched)"
                    class="alert">
                    <div *ngIf="recoverPasswordFrom.controls['currentEmail'].errors.required">
                        <p-message severity="error" text="Correo Electrónico es requerido"></p-message>
                    </div>
                    <div *ngIf="recoverPasswordFrom.controls['currentEmail'].errors.pattern">
                        <p-message severity="error" text="Correo Electrónico formato invalido"></p-message>
                    </div>
                    <div *ngIf="recoverPasswordFrom.controls['currentEmail'].hasError('maxlength')">
                        <p-message severity="error" text="Correo Electrónico excede formato longitud"></p-message>
                    </div>
                    <div *ngIf="recoverPasswordFrom.controls['currentEmail'].hasError('minlength')">
                        <p-message severity="error" text="Correo Electrónico infiere formato longitud"></p-message>
                    </div>
                </div>
                -->
            </div>
        </fieldset><br />

        <!-- INPUT -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-id-card"></i>
                    </span>
                    <span class="p-float-label">
                        <input tabIndex="2" id="currentCertifiedInput" formControlName="currentCertified"
                            aria-describedby="current-help" pInputText />
                        <label htmlFor="currentCertifiedInput">{{lbl_certificate}}</label>
                    </span>
                </div>
                <!--
                <div *ngIf="recoverPasswordFrom.controls['currentCertified'].invalid && (recoverPasswordFrom.controls['currentCertified'].dirty || recoverPasswordFrom.controls['currentCertified'].touched)"
                    class="alert">
                    <div *ngIf="recoverPasswordFrom.controls['currentCertified'].errors.pattern">
                        <p-message severity="error" text="Certificado ó télefono formato invalido"></p-message>
                    </div>
                    <div *ngIf="recoverPasswordFrom.controls['currentCertified'].hasError('maxlength')">
                        <p-message severity="error" text="Certificado ó télefono excede formato longitud"></p-message>
                    </div>
                    <div *ngIf="recoverPasswordFrom.controls['currentCertified'].hasError('minlength')">
                        <p-message severity="error" text="Certificado ó télefono infiere formato longitud"></p-message>
                    </div>
                </div>
                -->
            </div>
        </fieldset><br />

        <!-- INPUT -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-user"></i>
                    </span>
                    <span class="p-float-label">
                        <input tabIndex="3" id="currentIdGuideInput" formControlName="currentIdGuide"
                            aria-describedby="current-help" pInputText />
                        <label htmlFor="currentIdGuideInput">{{lbl_guide_id}}</label>
                    </span>
                </div>
                <!--
                <div *ngIf="recoverPasswordFrom.controls['currentIdGuide'].invalid && (recoverPasswordFrom.controls['currentIdGuide'].dirty || recoverPasswordFrom.controls['currentIdGuide'].touched)"
                    class="alert">
                    <div *ngIf="recoverPasswordFrom.controls['currentIdGuide'].errors.pattern">
                        <p-message severity="error" text="ID Guía SANTOV formato invalido"></p-message>
                    </div>
                    <div *ngIf="recoverPasswordFrom.controls['currentIdGuide'].hasError('maxlength')">
                        <p-message severity="error" text="ID Guía SANTOV excede formato longitud"></p-message>
                    </div>
                    <div *ngIf="recoverPasswordFrom.controls['currentIdGuide'].hasError('minlength')">
                        <p-message severity="error" text="ID Guía SANTOV infiere formato longitud"></p-message>
                    </div>
                    
                </div>
                -->
            </div>
        </fieldset><br />

        <!-- INPUT BUTTON -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <button tabIndex="4" pButton pRipple type="button" icon="pi pi-check" label="{{lbl_request}}"
                    class="p-button-raised p-button-success" (keyup.enter)="confirmRecoverPassword($event)"
                    (click)="confirmRecoverPassword($event)"></button>
            </div>
        </fieldset><br />

    </form>
</section>